// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__1ecIc"};